<script>
import TablePage from '@/found/components/table_page';
import Vue from 'vue';
import * as utils from '@/found/utils/index';
import Approve from '@/found/modules/approve';
import { ProcessLog } from '@/found/modules';
import FormPage from '../form/form';
import audit from '../audit/audit';
import DetailForm from '../form/detail.vue';
// 审核
export default {
  extends: TablePage,
  components: {
    FormPage,
    audit,
    DetailForm,
    Approve,
    ProcessLog,
  },
  data() {
    return {
      formShow: false,
      formConfig: {},
      modalConfig: {
        title: '新增',
        visible: false,
        type: 'Modal',
      },
      params: {
        orderType: '8',
      },
      typeList: [],
    };
  },
  async mounted() {
    await this.getConfigList('need-goods-list');
    this.getOrderType();
  },

  methods: {
    /**
     * 获取订单类型
     * */
    async getOrderType() {
      const { result } = await this.$http.post(
        '/dms/dms/order/orderTypeList',
        {},
      );
      this.typeList = result;
    },
    setColumn(v) {
      const rowData = v;
      if (rowData.field === 'branchList') {
        rowData.search = 'true';
        rowData.type = 'select';
        rowData.apiUrl = '/mdm/mdmOrgController/findOrgList';
        rowData.optionsKey = {
          label: 'orgName',
          value: 'orgCode',
        };
        rowData.multiple = true;
        // rowData.isSearch = true;
        rowData.paramsName = 'orgName';
        rowData.paramsFixed = {
          orgType: 'area',
        };
      }
      if (rowData.field === 'orderTypeList') {
        rowData.search = 'true';
        rowData.type = 'select';
        rowData.apiUrl = '/mdm/mdmdictdata/list';
        rowData.optionsKey = {
          label: 'dictValue',
          value: 'dictCode',
        };
        rowData.multiple = true;
        // rowData.isSearch = true;
        rowData.paramsName = 'dictValue';
        rowData.paramsFixed = {
          dictTypeCode: 'dms_order_type',
        };
      }
      if (rowData.field === 'actualAmount') {
        rowData.formatter = ({ row }) => {
          if (row.hide) {
            return '****';
          }
          return row.actualAmount;
        };
      }
      if (rowData.field === 'amount') {
        rowData.formatter = ({ row }) => {
          if (row.hide) {
            return '****';
          }
          return row.amount;
        };
      }
      return rowData;
    },

    clickVisible({ row, val: { code } }) {
      const {
        approveStatus,
        processCode,
        hasAccounted,
        isHaveCar,
        processInstanceId,
        isScan,
        applyStatus,
      } = row;
      // 审批通过 approved,审批中 approving,活动关闭 closed,流程追回 interrupt,驳回 rejected
      if (code === 'process_log' && !processCode) {
        return false;
      }
      if (
        approveStatus
        && code === 'edit'
        && (approveStatus === '2' || approveStatus === '1')
      ) {
        return false;
      }
      // if (code === 'confirm_the_inventory' && (approveStatus !== '2' || hasAccounted === 'Y')) {
      if (
        code === 'confirm_the_inventory'
        && (applyStatus !== '3' || isScan !== 'N')
      ) {
        return false;
      }
      if (
        code === 'isCart'
        && (isHaveCar === 'Y' || (approveStatus !== '1' && approveStatus !== '2'))
      ) {
        return false;
      }
      if (code === 'work-flow-deal' && !processInstanceId) {
        return false;
      }
      if (code === 'shipment_details' && approveStatus !== '2') {
        return false;
      }
      return true;
    },
    modalClick({ val, row }) {
      const formPageArg = {
        drawerTitle: '',
        code: val.code, // 按钮对应code
        orderCode: '', // 数据code
        formShow: true,
        formSource: val.parentCode,
      };
      if (val.code === 'add') {
        formPageArg.drawerTitle = '新增';
        this.createFormPage(formPageArg);
      }

      if (val.code === 'view') {
        formPageArg.drawerTitle = '查看';
        formPageArg.orderCode = row.orderCode;
        this.createFormPage(formPageArg);
      }
      if (val.code === 'shipment_details') {
        this.formName = 'DetailForm';
        this.modalConfig = {
          title: '发货详情',
          width: '80%',
        };

        this.formConfig = {
          ...this.formConfig,
          code: val.code,
          row,
          orderCode: row.orderCode,
        };

        this.openDrawer();
      }
      if (val.code === 'edit') {
        let flag = false;
        for (const item of this.typeList) {
          if (item.orderTypeCode === row.orderType) {
            flag = true;
          }
        }
        if (!flag) {
          this.$message.error('您无此订单类型编辑权限');
        } else {
          formPageArg.drawerTitle = '编辑';
          formPageArg.orderCode = row.orderCode;
          this.createFormPage(formPageArg);
        }
      }
      if (val.code === 'work-flow-deal') {
        this.createAudit(formPageArg, row);
      }
      if (val.code === 'need_goods_detail_export') {
        console.log(val);
        this.modalName = 'ExportModal';
        this.propsObjInData = {
          functionCode: val.doCode ? val.doCode : val.functionCode,
          requestUrl: val.queryUrl ? val.queryUrl : this.requestUrl, // 非导入导出文案的导入导出功能，查询数据接口不是列表接口，可通过查询接口传入
          visible: true,
          exportMessage: '',
          isExport: true,
          ids: this.selection,
          formData: {
            ...this.params,
            ...this.searchFormData,
            ...this.exportParams,
          },
          sid: utils.getUuid(32, 16),
        };
      }

      if (val.code === 'process_log') {
        this.formConfig = {
          ...this.formConfig,
          code: val.code,
          row: { processNo: row.processCode },
        };

        this.modalConfig.title = '流程日志';

        this.formName = 'ProcessLog';
        this.openDrawer();
      }
    },
    createAudit(arg, row) {
      const Component = Vue.extend(audit);
      const vm = new Component({
        el: document.createElement('div'),
        data() {
          return {
            ...arg,
            row: { ...row },
          };
        },
      });
      this.vm1 = vm;
      document.body.appendChild(vm.$el);
    },
    createFormPage(arg) {
      const that = this;
      const Component = Vue.extend(FormPage);
      const vm = new Component({
        el: document.createElement('div'),
        data() {
          return {
            ...arg,
          };
        },
        methods: {
          getParentTable() {
            that.getConfigList('need-goods-list');
          },
        },
      });
      vm.$on('submit', (data) => { // 表单提交 → 打开流程审批弹窗
        this.vm = vm; // 保存表单实例，审批提交成功后关闭表单抽屉
        this.onSubmitForm(data);
      });
      document.body.appendChild(vm.$el);
    },

    // 表单提交：打开流程审批弹窗（选审批流程后统一提交）
    onSubmitForm({ row, submitUrl }) {
      this.formName = 'Approve';
      this.formConfig = {
        row,
        submitUrl,
      };
      if (this.vm) {
        this.vm.formShow = false; // 先隐藏表单抽屉，避免盖住流程弹窗
      }
      this.modalConfig = {
        ...this.modalConfig,
        title: '提交审批',
        visible: true,
        type: 'Drawer',
        width: '700px',
        showFooter: false, // Approve 表单自带提交/取消按钮
      };
    },

    // 关闭流程弹窗：取消时恢复表单抽屉
    closeModal() {
      const restoreForm = this.formName === 'Approve' && this.vm;
      TablePage.methods.closeModal.call(this);
      if (restoreForm) {
        this.vm.formShow = true;
      }
    },

    // Approve 流程弹窗提交成功：关闭弹窗、关闭表单抽屉、刷新列表
    async onSubmit() {
      this.closeModal(); // 恢复表单抽屉后立即关闭
      if (this.vm) {
        this.vm.formShow = false;
      }
      this.getList();
    },
  },
};
</script>
